import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const SELECT_ITEM_CLASS_NAME = tv({
  base: clsx(
    "data-[disabled]:text-mauve8 data-[highlighted]:bg-violet9 data-[highlighted]:text-violet1 border-ui-200 relative flex cursor-pointer select-none items-center border-b py-[10px] px-5 leading-6 data-[disabled]:pointer-events-none data-[highlighted]:outline-none max-w-[600px] [&_span]:truncate",
    // hover
    "hover:bg-ui-200",
    // disabled
    "data-[disabled]:text-base-disabled",
    // selected
    "data-[state=checked]:bg-ui-300 data-[state=checked]:text-ui-white",
  ),
});
